// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"18174af7","364":"78536cd6","787":"87109f65"}[chunkId] + ".chunk.js";
};